import type { FC} from 'react';
import { memo } from 'react';

import Image from '../../../../shared/components/Image';
import { getFlagUrl, getLanguageName } from '../../shared/SettingsModal.helpers';
import { testIds } from '../../../../core/testIds';

import styles from './LanguageList.module.css';

export type LanguageListProps = {
  activeLanguageCode: string;
  supportedLanguages: string[];
  assetsHost: string;
  assetsHash?: string;
  onSelectLanguage: (code: string) => void;
};

const LanguageList: FC<LanguageListProps> = ({
  activeLanguageCode,
  supportedLanguages,
  assetsHost,
  assetsHash,
  onSelectLanguage,
}) => {
  
  return (
    <div className={styles.languageList}>
      {supportedLanguages.map((langCode) => {
        const isSelected = activeLanguageCode.toLowerCase() === langCode.toLowerCase();
        return (
          <div
            key={langCode}
            className={styles.languageOption}
            onClick={() => onSelectLanguage(langCode)}
            data-testid={testIds.settings.languageOption(langCode)}
          >
            <div className={styles.languageInfo}>
              <Image
                src={getFlagUrl(assetsHost, assetsHash ?? '', langCode)}
                alt={langCode}
                className={styles.flagImage}
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = 'none';
                }}
              />
              <div className={styles.languageName}>{getLanguageName(langCode)}</div>
            </div>
            <div className={`${styles.languageRadio} ${isSelected ? styles.languageRadioSelected : ''}`.trim()} />
          </div>
        );
      })}
    </div>
  );
};

export default memo(LanguageList);
